import {
    Box,
    CellItem,
    Grid,
    IconAvatar,
    Stack,
    Typography,
    UserAvatar,
} from "@biggeo/bg-ui/lab";
import { AddOutline, ArrowForwardOutline } from "@biggeo/bg-ui/lab/icons";
import React from "react";

const CreateOrganizationPrompt = ({
    firstName,
    lastName,
    img,
    onClickContinue,
}: {
    readonly firstName?: string;
    readonly lastName?: string;
    readonly img?: string;
    readonly onClickContinue: () => void;
}) => {
    return (
        <Stack rowGap={4}>
            <Grid container columnGap={2} alignItems="center">
                <Grid item>
                    <UserAvatar
                        src={img}
                        alt={
                            firstName && lastName
                                ? `${firstName} ${lastName}`
                                : undefined
                        }
                        size="sm"
                    />
                </Grid>
                <Grid item>
                    <Typography variant="h5" fontWeight="bold">
                        {`${firstName ? `Hello ${firstName},` : "Hello,"} Welcome Back!`}
                    </Typography>
                </Grid>
            </Grid>
            <Typography
                variant="body1"
                sx={{
                    color: (theme) => theme.palette.disabled.onContainer,
                }}
            >
                Looks like you’re not a member of any organization. Create one
                to use Datascape
            </Typography>
            <Box
                sx={{
                    padding: 2,
                }}
            >
                <CellItem
                    startNode={
                        <IconAvatar size="md">
                            <AddOutline />
                        </IconAvatar>
                    }
                    title="Create Organization"
                    endNode={<ArrowForwardOutline />}
                    onClick={onClickContinue}
                    variant="outlined"
                />
            </Box>
        </Stack>
    );
};

export default CreateOrganizationPrompt;
